var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileInfoReminderExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30.5C18.4045 30.5025 20.2908 30.1285 22.0503 29.3997C23.8099 28.6708 25.408 27.6014 26.7529 26.2529C28.1014 24.908 29.1708 23.3099 29.8997 21.5503C30.6285 19.7908 31.0025 17.9045 31 16C31.0024 14.0955 30.6285 12.2093 29.8996 10.4497C29.1708 8.69017 28.1014 7.09201 26.7529 5.74706C25.408 4.39858 23.8099 3.32918 22.0503 2.60033C20.2908 1.87148 18.4045 1.49754 16.5 1.50001C14.5955 1.49758 12.7093 1.87154 10.9497 2.60039C9.19017 3.32924 7.59201 4.39861 6.24706 5.74706C4.89861 7.09201 3.82924 8.69017 3.10039 10.4497C2.37154 12.2093 1.99758 14.0955 2.00001 16C1.99754 17.9045 2.37148 19.7908 3.10033 21.5503C3.82918 23.3099 4.89858 24.908 6.24706 26.2529C7.59201 27.6014 9.19017 28.6708 10.9497 29.3996C12.7093 30.1285 14.5955 30.5024 16.5 30.5V30.5Z",
    stroke: "#FFD400",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 25.425C16.9807 25.425 17.4417 25.2341 17.7816 24.8942C18.1215 24.5543 18.3125 24.0933 18.3125 23.6125C18.3125 23.1318 18.1215 22.6708 17.7816 22.3309C17.4417 21.991 16.9807 21.8 16.5 21.8C16.0193 21.8 15.5583 21.991 15.2184 22.3309C14.8785 22.6708 14.6875 23.1318 14.6875 23.6125C14.6875 24.0933 14.8785 24.5543 15.2184 24.8942C15.5583 25.2341 16.0193 25.425 16.5 25.425Z",
    fill: "#FFD400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.30005V18.9",
    stroke: "#FFD400",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInfoReminderExclamation);
export default __webpack_public_path__ + "static/media/profile-info-reminder-exclamation.e4320d4633d64d3c5d8b5855638a28c2.svg";
export { ForwardRef as ReactComponent };